import {all} from 'redux-saga/effects';
import Auth from './Auth';
import Notifications from "./Notifications";

export default function* rootSaga(getState) {
    yield all([
        Auth(),
        Notifications(),
    ]);
}
